import { UserApi } from "./modules/user.js";
import { TransactionsApi } from "./modules/transactions.js";
import { ExchangeApi } from "./modules/exchange.js";
import { WithdrawApi } from "./modules/withdraw.js";
import { CoinholdApi } from "./modules/coinhold.js";
import { StakingApi } from "./modules/staking.js";
import { SettingsApi } from "./modules/settings.js";
import { P2PApi } from "./modules/p2p.js";
import { GiftCardsApi } from "./modules/giftCards.js";
import { CardsApi } from "./modules/card.js";
import { RewardsCentreApi } from "./modules/rewardsCentre.js";

export class ApiClient {
  /**
   * Инициализируем все под‑клиенты. Вызывать один раз в точке входа
   * приложения, когда Pinia‑сторы уже существуют.
   * @param {Object} stores – { user, exchange, p2p, withdraw, coinhold, staking, ui, coins }
   *   coins — адаптер useCoins() над coin-service, чтобы модули не импортили
   *   композабл напрямую в обход этой инъекции.
   * @param {Object} [facade] – ApiFacade (axios+интерсепторы). Пока хранится,
   *   но модули ещё на fetch-фасаде Request.
   */
  init(stores, facade = null) {
    this.facade = facade;
    this.user = new UserApi(stores);
    this.transactions = new TransactionsApi(stores);
    this.exchange = new ExchangeApi(stores);
    this.withdraw = new WithdrawApi(stores);
    this.coinhold = new CoinholdApi(stores);
    this.staking = new StakingApi(stores);
    this.settings = new SettingsApi(stores);
    this.p2p = new P2PApi(stores);
    this.giftCards = new GiftCardsApi(stores);
    // createCard после заявки обновляет KYC-статус через UserApi — без циклического импорта index.js
    this.card = new CardsApi({ ...stores, userApi: this.user });
    this.rewardsCentre = new RewardsCentreApi(stores);
  }
}

export const api = new ApiClient();
